<template>
    <div>
        <user-select @change="updateUser" :currentValue="currentDriver" :mode="mode" :options="drivers" ref="el"/>
    </div>
</template>

<script>
    import epoch from 'epoch.js'
    import UserSelect from './UserSelect.vue'

    export default {
        props: [
            'trip',
            'noempty',
            'mode',
            'close',//function from parent to close the modal
        ],
        data () {
          return {
          }
        },
        components: {
            'user-select': UserSelect
        },
        methods: {
            updateUser(userSelected) {
                if(userSelected) {
                  this.$eventHub.$emit('updateTrip', this.trip.id, {drivers: [userSelected], assigned_time: epoch().datetime(), dispatcher: this.$privateReactiveStore.getUser().id, transit_action_stage: 1});
                }
                else {
                    this.$eventHub.$emit('updateTrip', this.trip.id, {drivers: [], assigned_time: null, dispatcher: this.$privateReactiveStore.getUser().id, transit_action_stage: 0});
                }
            },
        },
        computed: {
            drivers () {
                let drivers = [{full_name: null, id: null}];
                let separatorAlready = false

                // Add all drivers one by one
                for (let i = 0; i < this.$privateReactiveStore.drivers.length; i++) {
                    if (!separatorAlready && this.$privateReactiveStore.drivers[i].role !== 'driver') {
                        // Insert a separator between drivers and backup drivers
                        drivers.push({
                            disabled: "1",
                            full_name: '──────────',
                            id: '',
                        })

                        separatorAlready = true
                    }

                    drivers.push(this.$privateReactiveStore.drivers[i])
                }
                
                return drivers
            },
            currentDriver() {
                let driver = {full_name: null, id: null};

                if(this.trip.drivers.length > 0) {
                    driver = this.trip.drivers[0];
                }
                
                return driver;
            }
        }
    }
</script>

<style lang="less" scoped>

</style>